import Router from '@/layout/router'
import { Message } from 'element-ui'
import { DeptInterface } from './dept-api-code-trace'
import { logReport } from './common'

import { ENV } from '../config'

const isProd = ENV === 'prd'

/**
 * 请求拦截-通用参数增加请求头
 */
export function handleRequestGray (config) {
  if (config.headers.method === 'system.genericSearch.listByMenuId' && document.cookie && document.cookie.includes('gray-sys=1')) {
    config.headers['X-sys-gray'] = 1
  }
  return config
}

/**
 * 请求拦截-非生产环境多版本添加版本标识请求头
 */
 export function handleMultiVersionHeaders (config) {
  if (isProd) {
    return config
  }
  const multiSessionStr = sessionStorage.getItem('ERPMULTIMODULE')
  if (multiSessionStr) {
    const multiSessionData = JSON.parse(multiSessionStr)
    const envId = multiSessionData.envId
    if (envId) {
    config.headers['x-envid'] = envId
    }
  }
  return config
}

/**
 * 请求拦截-针对某些菜单某些请求，增加特定请求头（菜单：成本管理）
 */
export function handleRequestTempAuth (config) {
  const menuIds = ['152995231408803407']
  let value = sessionStorage.getItem('FMS_ANALYZE_TEMPORARY_AUTH')
  let menuId = window.__ERPMODULE__.id
  if (menuId && menuIds.includes(menuId) && value) {
    config.headers['X-temporary-auth'] = value
  }
  return config
}


/**
 * 响应拦截-针对接口响应添加了灰度标识，判断路由meta标识是否需要弹窗提示接口正在灰度
 */
export function handleResponseGrayTips (response) {
  try {
    const data = typeof response.data === 'object' ? response.data : {}
    const method = (response && response.config && response.config.headers && response.config.headers.method) || response.config.url
    if (data.code === 0) {
      // 判断该接口是否存在灰度标识
      if (response.headers['x-framework-isgray'] && response.headers['x-framework-isgray'] === '1') {
        // 灰度标识接口且判断当前路由meta是否配置弹窗
        if (Router.currentRoute && Router.currentRoute.meta && Router.currentRoute.meta.showGrayMessage) {
          Message.closeAll()
          Message({ message: `${method}接口正在灰度`, type: 'warning', duration: 3000 })
        }
      }
    }
    return response
  } catch (error) {
    window._apm && window._apm('captureException', new Error(`handleResponseGrayTips${error}`))
  }
}

/**
 *
 * @desc 拦截组织树接口是否是公共组件发出。不是则上报
 * @export
 * @param {*} config
 */
export function handleRequestDeptInterface(config) {
  try {
    if (config) {
      if (config.headers) {
        const { isFromCommonComponent, method } = config.headers
        if (method && DeptInterface.indexOf(method) > -1 && !isFromCommonComponent) {
          setTimeout(() => {
            // 上报
            logReport({
              menuId: config.headers['X-menu-id'], // 菜单id
              logId: 'public-dept-interface-tag', // 日志id 建议：部门标识 + 编码，方便识别
              log: `${method}：接口未从公共组件处使用` // 日志详情
            })
          })
        }
      }
    }
    return config
  } catch (error) {
    window._apm && window._apm('captureException', new Error(`handleRequestDeptInterface${error}`))
  }
}








// WEBPACK FOOTER //
// ./src/public/utils/http-interceptors.js